import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19fcf94a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("返回列表")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重新申请")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("申请审批")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("撤回申请")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重新发起")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("修改出纳、会计")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("回传")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("撤回回传")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("回传")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("撤回回传")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("补充资料申请")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_17 = {
  key: 15,
  class: "tips"
}

import {
  withDefaults,
  ref,
  getCurrentInstance,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { message } from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    typeList: { default: () => [] },
    showTips: { default: "" },
    isBottom: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { typeList: (number | string)[], showTips: string, isBottom: boolean }

const $bus = getCurrentInstance().appContext.config.globalProperties.$bus;

const store = useStore();
const router = useRouter();
const route = useRoute();
const value = ref<number>(0);


const goback = () => {
  if (route.path.indexOf("process") != -1) {
    router.push("/processlist");
  } else if (route.path.indexOf("changeProcess") >= 0) {
    router.push("/changelist");
  } else {
    if (route.path.indexOf("open") >= 0) {
      window.location.reload();
    } else {
      router.go(-1);
    }
  }
};
const submit = function (type: number | string) {
  if (props.showTips && type == "100") {
    message.error(props.showTips);
    return;
  }
  $emit("click", type);

  $bus.emit("click", type);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["formal-footer", 
        !__props.isBottom && (__props.typeList.includes('100') || __props.typeList.includes('-2'))
          ? 'rePositon'
          : ''
      ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.typeList, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (item == 90)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: goback,
                  class: "btn-back btn",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (item == 305)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  onClick: ($event: any) => (submit(item)),
                  style: {"color":"#fff"},
                  danger: "",
                  class: "btn btn-reject btn-back",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 100 || item == -3)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 2,
                  type: "primary",
                  size: "large",
                  class: _normalizeClass(["btn btn-back", __props.showTips ? 'disalbe' : '']),
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              : _createCommentVNode("", true),
            (item == 101)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 3,
                  type: "primary",
                  size: "large",
                  class: "btn btn-back",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 102)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 4,
                  type: "primary",
                  size: "large",
                  class: "btn btn-back",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 103 || item == 105)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 5,
                  type: "primary",
                  size: "large",
                  class: "btn btn-back",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 104)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 6,
                  type: "primary",
                  size: "large",
                  danger: "",
                  onClick: ($event: any) => (submit(item)),
                  class: "btn btn-reject btn-back"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 106)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 7,
                  type: "primary",
                  size: "large",
                  class: "btn btn-back btn-edit",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 201 || item == 401 || item == 501)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 8,
                  type: "primary",
                  size: "large",
                  class: "btn btn-back",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 202 || item == 402 || item == 502)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 9,
                  type: "primary",
                  class: "btn btn-back",
                  size: "large",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 301)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 10,
                  type: "primary",
                  class: "btn",
                  size: "large",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 302)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 11,
                  type: "primary",
                  size: "large",
                  class: "btn btn-back",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == 303 || item == 601 || item == 306)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 12,
                  type: "primary",
                  size: "large",
                  class: "btn btn-back",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == -1)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 13,
                  size: "large",
                  class: "btn btn-back",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (item == -2)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 14,
                  type: "primary",
                  size: "large",
                  class: "btn btn-back",
                  onClick: ($event: any) => (submit(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (__props.showTips && item == '100')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(__props.showTips), 1))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ], 2)
  ]))
}
}

})